import { render, staticRenderFns } from "./HmBaseTransfer.vue?vue&type=template&id=fff30c4e&scoped=true&"
import script from "./HmBaseTransfer.vue?vue&type=script&lang=js&"
export * from "./HmBaseTransfer.vue?vue&type=script&lang=js&"
import style0 from "./HmBaseTransfer.vue?vue&type=style&index=0&id=fff30c4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff30c4e",
  null
  
)

component.options.__file = "HmBaseTransfer.vue"
export default component.exports